import React from "react";

export function AIResultsBlock({ children }: React.PropsWithChildren) {
  const childrenLength = React.Children.toArray(children).length;

  if (!childrenLength) {
    return null;
  }

  return (
    <div className="flex-1 mt-8 flex flex-col gap-6 w-full">{children}</div>
  );
}
